module.exports = __webpack_public_path__ + "static/img/10018 (4).15808f5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10018 (4).webp
// module id = 1vse
// module chunks = 14